import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import {
  isActiveISOSettingSelector, // [crm-iso]
  userSelector,
} from "appredux/selectors";

const useMeetingFinishedHandler = () => {
  const currentUser = useSelector(userSelector);
  const isActiveISO = useSelector(isActiveISOSettingSelector); // [crm-iso]
  const [finishedSchedule, setFinishedSchedule] = useState(null);

  const meetingFinishedHandler = useCallback(
    (payload) => {
      // [crm-iso] Agen terpengaruh tidak menerima notifikasi meeting schedule.
      // TEARDOWN: hapus baris di bawah + isActiveISO dari deps.
      if (isActiveISO) return;
      if (payload.schedule_admin_agent_id !== currentUser.id) return;

      // Hanya satu modal pada satu waktu: abaikan pusher baru saat modal terbuka.
      setFinishedSchedule((prev) => (prev ? prev : payload));
    },
    [currentUser.id, isActiveISO] // [crm-iso] deps: isActiveISO
  );

  const closeFinished = useCallback(() => {
    setFinishedSchedule(null);
  }, []);

  return { meetingFinishedHandler, finishedSchedule, closeFinished };
};

export default useMeetingFinishedHandler;
